<template>
  <div class="mt-12">
    <v-card :loading="load"
            outlined
            width="500"
            class="mx-auto">
      <v-toolbar flat>
        <v-toolbar-title>
          Авторизация
        </v-toolbar-title>

      </v-toolbar>
      <v-card-text>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field
              color="foodison"
              prepend-icon="person"
              name="login"
              label="Логин"
              type="number"
              v-model="login"
              :rules="loginRules"
              required
              @keyup.enter="onLogin"
              :autofocus="true"
          ></v-text-field>
          <v-text-field
              prepend-icon="lock"
              name="password"
              label="Пароль"
              type="password"
              v-model="password"
              :rules="pasRules"
              required
              @keyup.enter="onLogin"
              v-if="loginByCall === false"
          ></v-text-field>
          <v-text-field
              prepend-icon="lock"
              name="code"
              label="Последние 4-е цифры"
              type="number"
              v-model="code"
              :rules="codeRules"
              required
              @keyup.enter="onLogin"
              v-if="loginByCall && codeSend"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-text
      v-if="loginByCall"
      >
        На Ваш телефон поступит звонок оповещение, Вам необходимо будет ввести последние четыре цифры номера телефона с которого совершен звонок
      </v-card-text>

      <v-card-actions>
        <v-btn
            color="foodison"
            text
            @click="changeLoginType"
            :loading="load"
            :disabled="load"
            v-if="loginByCall === false"
        >Войти по звонку
        </v-btn>
        <v-btn
            color="foodison"
            text
            @click="changeLoginType"
            :loading="load"
            :disabled="load"
            v-if="loginByCall === true"
        >Войти по паролю
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="foodison"
            text
            @click="onLogin"
            :loading="load"
            :disabled="load"
            v-if="loginByCall === false || codeSend"
        >Войти
        </v-btn>
        <v-btn
            color="foodison"
            text
            @click="sendCode"
            :loading="load"
            :disabled="load"
            v-if="loginByCall === true && !codeSend"
        >Отправить код
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>

</template>
<script>
export default {
  name: 'Login',
  metaInfo: {
    title: 'Авторизация',
  },
  data() {
    return {
      load: false,
      login: '',
      password: '',
      valid: false,
      loginRules: [
        v => !!v || 'Обязательное поле',
        v => v.length >= 3 || 'Минимум 3 символа'
      ],
      pasRules: [
        v => !!v || 'Обязательное поле',
        v => v.length >= 6 || 'Минимум 6 символов'
      ],
      codeRules: [
        v => !!v || 'Обязательное поле',
        v => v.length === 4 || 'Должно быть 4 цифры'
      ],
      loginByCall: false,
      code: '',
      codeSend: false
    }
  },
  methods: {
    async onLogin() {
      if (this.$refs.form.validate()) {
        const user = {
          username: this.login,
          password: this.password,
          code: this.code,
        }

        this.load = true
        let type = this.loginByCall?'user/loginByCodeUser':'user/loginUser';
        let res = await this.$store.dispatch(type, user)
        if (res) {
          this.$router.push('/')
        }
        this.load = false
      }
    },
    changeLoginType() {
      this.loginByCall = !this.loginByCall
    },
    async sendCode() {
      if (this.$refs.form.validate()) {
        const user = {
          username: this.login,
        }

        this.load = true
        let res = await this.$store.dispatch('user/sendCode', user)
        if (res) {
          this.codeSend = true;
          this.$router.push('/')
        }
        this.load = false
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },
  mounted() {
    const message = this.$route.query.message;
    if (message) {
      const {commit} = this.$store
      commit('infoSnackbar/clearSnackbar')
      commit('infoSnackbar/setSnackbarMsg', 'Требуется авторизация')
      commit('infoSnackbar/setSnackbarType', 'error')
    }
  }
}
</script>
<style>

</style>

